const Sales = () => import(/* webpackChunkName: "sales" */ './Sales');

export default {
  path: '/:publicName/:campaignSlug',
  component: Sales,
  name: 'sales',
  props: true,
};

export const wlRoutes = {
  path: '/:campaignSlug',
  component: Sales,
  name: 'sales',
  props: true,
};